<div class="flex-container flex-dir-column align-spaced full-height-column">

  <div class="flex-container align-right margin-b-3">
    <div (click)="handleFilterOverlay()">
      <svg xmlns="http://www.w3.org/2000/svg" width="29.366" height="29.366" viewBox="0 0 29.366 29.366">
        <g id="Gruppe_39" data-name="Gruppe 39" transform="translate(0.798 0.798)">
          <g id="Gruppe_35" data-name="Gruppe 35" transform="translate(0.202 0.202)">
            <circle id="Ellipse_2" data-name="Ellipse 2" cx="13.683" cy="13.683" r="13.683" fill="none"
                    stroke="#023e84"
                    stroke-miterlimit="10" stroke-width="2"/>
            <line id="Linie_9" data-name="Linie 9" x2="11.397" y2="11.397" transform="translate(7.985 7.985)"
                  fill="none" stroke="#023e84" stroke-miterlimit="10" stroke-width="2"/>
            <line id="Linie_10" data-name="Linie 10" x1="11.397" y2="11.397" transform="translate(7.985 7.985)"
                  fill="none" stroke="#023e84" stroke-miterlimit="10" stroke-width="2"/>
          </g>
        </g>
      </svg>
    </div>
  </div>
  <div class="scroll-container">
    <app-product-sections-filter></app-product-sections-filter>
    <app-product-category></app-product-category>
    <app-color-filter></app-color-filter>
    <app-shape-filter></app-shape-filter>
    <div class="grid">
      <div class="xs-12 m-5 filter-box">
        <div class="grid align-middle">
          <div class="xs-12 title xs-margin-r-3">{{'search-filter-overlay.brand' | i18next}}</div>
          <div class="xs-12 margin-r-3">
            <ng-select (change)="selectBrand(selectedBrand)" [(ngModel)]="selectedBrand"
                       (clear)="checkFilterable()">
              <ng-option *ngFor="let brand of brandOptions | keyvalue"
                         [value]="brand.key">{{brand.value}}</ng-option>
            </ng-select>
          </div>
          <div class="xs-12 title xs-margin-r-3">{{'search-filter-overlay.material' | i18next}}</div>
          <div class="xs-12 margin-r-3">
            <ng-select (change)="selectMaterial(selectedMaterial)"
                       (clear)="checkFilterable()"
                       [(ngModel)]="selectedMaterial">
              <ng-option *ngFor="let material of materialOptions | keyvalue"
                         [value]="material.key">{{material.value}}</ng-option>
            </ng-select>
          </div>

          <div class="xs-12 title xs-margin-r-3">{{'search-filter-overlay.style' | i18next}}</div>
          <div class="xs-12 margin-r-3">
            <ng-select (change)="selectStyle(selectedStyle)" [(ngModel)]="selectedStyle">
              <ng-option *ngFor="let style of styleOptions | keyvalue"
                         [value]="style.key">{{style.value}}</ng-option>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="xs-12 m-7 filter-box ">
        <div class="grid align-center margin-b-3" *ngIf="priceActive">
          <div class="xs-12 m-3 title xs-margin-r-3">{{'search-filter-overlay.price' | i18next}}</div>
          <div class="xs-12 m-9">
            <div class="flex-container grid-gap-5 margin-r-3"
                 *ngIf="priceActive && priceRange.startPrice !== undefined && priceRange.endPrice !== undefined">
              <div class="shrink range-input">
                <input type="number" [(ngModel)]="priceRange.startPrice">
              </div>
              <ngx-slider [(value)]="priceRange.startPrice"
                          [(highValue)]="priceRange.endPrice"
                          [options]="optionsPriceRange"
                          (valueChange)="priceRangeStart($event)"
                          (highValueChange)="priceRangeEnd($event)"
              ></ngx-slider>
              <div class="shrink range-input"><input type="number" [(ngModel)]="priceRange.endPrice"></div>
            </div>
          </div>
        </div>
        <div class="grid align-center margin-b-3">
          <div class="xs-12 m-3 title xs-margin-r-3">{{'search-filter-overlay.content' | i18next}}</div>
          <div class="xs-12 m-9">
            <div class="flex-container grid-gap-5 margin-r-3"
                 *ngIf="volumeRange.startVolume !== undefined && volumeRange.endVolume !== undefined">
              <div class="shrink range-input"><input type="number" [(ngModel)]="volumeRange.startVolume"></div>
              <ngx-slider [(value)]="volumeRange.startVolume"
                          [(highValue)]="volumeRange.endVolume"
                          [options]="optionsVolumeRange"
                          (valueChange)="volumeRangeStart($event)"
                          (highValueChange)="volumeRangeEnd($event)"
              ></ngx-slider>
              <div class="shrink range-input"><input type="number" [(ngModel)]="volumeRange.endVolume"></div>
            </div>
          </div>
        </div>
        <div class="grid align-center">
          <div class="xs-12 m-3 title xs-margin-r-3">{{'search-filter-overlay.diameter' | i18next}}</div>
          <div class="xs-12 m-9">
            <div class="flex-container grid-gap-5 margin-r-3"
                 *ngIf="diameterRange.startDiameter !== undefined && diameterRange.endDiameter !== undefined">
              <div class="shrink range-input"><input type="number" [(ngModel)]="diameterRange.startDiameter"></div>
              <ngx-slider [(value)]="diameterRange.startDiameter"
                          [(highValue)]="diameterRange.endDiameter"
                          [options]="optionsDiameterRange"
                          (valueChange)="diameterRangeStart($event)"
                          (highValueChange)="diameterRangeEnd($event)"
              ></ngx-slider>
              <div class="shrink range-input"><input type="number" [(ngModel)]="diameterRange.endDiameter"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer grid align-center grid-gap-big">
    <div class="xs-12 m-6 show-for-m">
      <div class="flex-container align-spaced align-center">
        <div class="product-count">
          <ng-container *ngIf="filteredProductsLength > 0">
            400 {{'search-filter-overlay.products-found' | i18next}}</ng-container>
        </div>
        <div class="abort"><a (click)="handleFilterOverlay()">{{'search-filter-overlay.cancel' | i18next}}</a></div>
      </div>
    </div>
    <div class="xs-12 m-6">
      <div class="flex-container align-center grid-gap-big">
        <div>
          <button class="btn primary full outlined" [ngClass]="{'disabled': !filterable}"
                  (click)="resetFilters()">{{'search-filter-overlay.reset-filter' | i18next}}</button>
        </div>
        <div>
          <button class="btn primary full" [ngClass]="{'disabled': !filterable}"
                  (click)="applyFilters()">{{'search-filter-overlay.use-filter' | i18next}}</button>
        </div>
      </div>
    </div>
  </div>
</div>


